import { IHttpAdapter } from '../../entity/interface/iHttpAdapter';
import { API_IDS } from '@intigral/constant';
import { IGeoLocationGetMyLocationResponse } from '../../entity/interface/iGeoLocation';
import { IGeoLocationRepository } from '../../core/repositories/interfaces/iGeoLocationRepository';
import { container } from '../../DataDomain';
import { IApiPathManager } from '../config/ApiPathManager';
import { DI } from '@intigral/constant/config/DIContainer';

class GeoLocationRepository implements IGeoLocationRepository {
    // Lazy getters for dependencies to avoid circular dependencies
    private get http(): IHttpAdapter {
        return container.resolve<IHttpAdapter>(DI.UTILS.IHttpAdapter);
    }

    private get apiPathManager(): IApiPathManager {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async getMyLocation(): Promise<IGeoLocationGetMyLocationResponse> {
        const path = this.apiPathManager.getPath(API_IDS.GEO_LOCATION_API_GET_MY_LOCATION);
        const response = await this.http.get<IGeoLocationGetMyLocationResponse>(path, {
            params: {},
            headers: {},
        });
        return response.data;
    }
}

export default GeoLocationRepository;
